const updateFunc = (controlData) => {
  const prevalence =
    controlData["prevalence"] !== undefined ? controlData["prevalence"] : 10;
  const h = 1000 - prevalence;
  const d = prevalence;

  const jsonHealthy = { Status: "Healthy" };
  const jsonDiseased = { Status: "Diseased" };
  const repeatedHealthy = Array(h).fill(jsonHealthy);
  const repeatedDiseased = Array(d).fill(jsonDiseased);
  const calculatedData = repeatedHealthy.concat(repeatedDiseased);

  return calculatedData;
};

export default updateFunc;
